import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { OwnerLogo } from './OwnerLogo.js';
import { TenantLogo } from './TenantLogo.js';
/**
 * Letterhead — owner brand on the left with the contract title and formulär
 * number stacked below it; tenant brand on the right. Mounts inside
 * <TemplateDocument>'s `header` slot so it repeats on every printed page.
 * Defaults to <OwnerLogo>/<TenantLogo> for the logo slots; templates can
 * pass custom marks when needed.
 *
 * The user-entered avtalsnummer + objektsnummer live in the document body,
 * not here — the contract row UUID is not displayed.
 */
export function TemplateLetterhead(props) {
    // `width: 100%` is on the inline style (not via Tailwind utility)
    // because Chromium's print-mode header rendering ignores `width:
    // 100%` from external stylesheets but honours it as an inline
    // attribute. Without it, the flex row collapses to content-width and
    // `justify-between` stops pushing the tenant logo to the right edge.
    return (_jsxs("div", { className: "flex items-start justify-between gap-4", style: { width: '100%' }, children: [_jsxs("div", { className: "flex flex-col items-start text-left", children: [_jsx("div", { className: "flex-shrink-0", children: props.logo ?? _jsx(OwnerLogo, {}) }), _jsx("span", { className: "mt-3 text-[12px] font-semibold leading-tight", children: props.title }), _jsx("span", { className: "mt-0.5 font-sans text-[9px] uppercase tracking-[0.15em] text-stone-500", children: props.formNumber })] }), _jsx("div", { className: "flex-shrink-0", children: props.tenantLogo ?? _jsx(TenantLogo, {}) })] }));
}
//# sourceMappingURL=Letterhead.js.map